<div class="wide-header">
    <div class="logo"></div>
    <div class="wide-header__text">
        <h3>СЕРВИС</h3>
        <div>вступительных и переводных испытаний</div>
    </div>
    <div class="wide-header__button" role="button" (click)="onClick($event)"></div>
</div>
